import React from 'react';
import { MapPin, Wifi } from 'lucide-react';
const LOGO = 'https://cdn.magicpatterns.com/uploads/atBL8cv61rZ8XfNmSHojX8/cropped-AllStar-White-Background.png';
const LINKS = [{
  label: 'Fiber Services',
  href: '#services'
}, {
  label: 'Why AllStar',
  href: '#why-us'
}, {
  label: 'About',
  href: '#about'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Footer() {
  return <footer className="w-full bg-ink text-white" data-id="element-68">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8" data-id="element-69">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-70">
          <div data-id="element-71">
            <div className="inline-flex rounded-xl bg-white/95 px-3 py-2" data-id="element-72">
              <img src={LOGO} alt="AllStar Home Solutions" className="h-8 w-auto" data-id="element-73" />
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60" data-id="element-74">
              Local guidance for households exploring fiber internet in
              Vancouver, Washington.
            </p>
          </div>

          <div data-id="element-75">
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wide text-white" data-id="element-76">
              Explore
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-77">
              {LINKS.map(link => <li key={link.href} data-id="element-78">
                  <a href={link.href} className="text-sm text-white/60 transition-colors hover:text-brand" data-id="element-79">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-80">
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wide text-white" data-id="element-81">
              Vancouver, WA
            </h3>
            <div className="mt-4 space-y-4 text-sm text-white/60" data-id="element-82">
              <p className="flex items-start gap-3" data-id="element-83">
                <MapPin className="mt-0.5 h-5 w-5 flex-shrink-0 text-brand" aria-hidden="true" data-id="element-84" />
                <span data-id="element-85">Serving Vancouver, Washington households.</span>
              </p>
              <p className="flex items-start gap-3" data-id="element-86">
                <Wifi className="mt-0.5 h-5 w-5 flex-shrink-0 text-brand" aria-hidden="true" data-id="element-87" />
                <span data-id="element-88">Fiber internet availability and plan guidance.</span>
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-8" data-id="element-89">
          <p className="text-sm text-white/50" data-id="element-90">
            © {new Date().getFullYear()} AllStar Home Solutions. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}